/**
 * @desc 打点统计
 */
import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { LIST_TYPE, PLATFORM } from '@umu/umu-types';

export enum EEventType {
    HIT = 'hit',
}
export interface IInput {
    search_id: string;
    page_index: LIST_TYPE;
    event: EEventType;
    page: number;
    from: PLATFORM;
    eid?: string;
    topic_id?: string;
}

export const viewLog = (data: IInput): Promise<IResponse<{}>> => {
    return fetchData(Api.STAT_SEARCH, data, { silent: true }).then((res: IResponse<{}>) => {
        return res;
    });
};

export const viewLogSync = fetchDataSync(viewLog);
